import appleIcon from '@/assets/social-networks/apple.svg';
import blueskyIcon from '@/assets/social-networks/bluesky.svg';
import discordIcon from '@/assets/social-networks/discord.svg';
import facebookIcon from '@/assets/social-networks/facebook.svg';
import g2Icon from '@/assets/social-networks/g2.svg';
import googleAnalyticsIcon from '@/assets/social-networks/google-analytics.svg';
import googleBusinessIcon from '@/assets/social-networks/google-business.svg';
import googlePlayIcon from '@/assets/social-networks/google-play.svg';
import googleIcon from '@/assets/social-networks/google.svg';
import instagramIcon from '@/assets/social-networks/instagram.svg';
import linkedinIcon from '@/assets/social-networks/linkedin.svg';
import mastodonIcon from '@/assets/social-networks/mastodon.svg';
import pinterestIcon from '@/assets/social-networks/pinterest.svg';
import redditIcon from '@/assets/social-networks/reddit.svg';
import threadsIcon from '@/assets/social-networks/threads.svg';
import tiktokIcon from '@/assets/social-networks/tiktok.svg';
import websiteIcon from '@/assets/social-networks/website.svg';
import whatsappIcon from '@/assets/social-networks/whatsapp.svg';
import xIcon from '@/assets/social-networks/x.svg';
import youtubeIcon from '@/assets/social-networks/youtube.svg';

export const socialNetworkIconMap = {
    Apple: appleIcon,
    Bluesky: blueskyIcon,
    Discord: discordIcon,
    Facebook: facebookIcon,
    G2: g2Icon,
    GoogleAnalytics: googleAnalyticsIcon,
    GoogleBusiness: googleBusinessIcon,
    Google: googleIcon,
    GooglePlay: googlePlayIcon,
    Instagram: instagramIcon,
    LinkedIn: linkedinIcon,
    Mastodon: mastodonIcon,
    Pinterest: pinterestIcon,
    Reddit: redditIcon,
    Threads: threadsIcon,
    TikTok: tiktokIcon,
    Website: websiteIcon,
    WhatsApp: whatsappIcon,
    X: xIcon,
    YouTube: youtubeIcon,
};

const socialNetworkAliases = {
    apple: 'Apple',
    appstore: 'Apple',
    bluesky: 'Bluesky',
    discord: 'Discord',
    facebook: 'Facebook',
    g2: 'G2',
    googleanalytics: 'GoogleAnalytics',
    googlebusiness: 'GoogleBusiness',
    google: 'Google',
    googlemybusiness: 'GoogleBusiness',
    googleplay: 'GooglePlay',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    mastodon: 'Mastodon',
    pinterest: 'Pinterest',
    reddit: 'Reddit',
    threads: 'Threads',
    tiktok: 'TikTok',
    tik_tok: 'TikTok',
    twitter: 'X',
    website: 'Website',
    web: 'Website',
    whatsapp: 'WhatsApp',
    x: 'X',
    youtube: 'YouTube',
};

export const socialNetworkOptions = [
    'Facebook',
    'X',
    'LinkedIn',
    'Pinterest',
    'Instagram',
    'Mastodon',
    'Bluesky',
    'Threads',
    'YouTube',
    'TikTok',
    'GoogleBusiness',
    'GooglePlay',
    'Apple',
    'G2',
    'GoogleAnalytics',
    'WhatsApp',
    'Discord',
    'Website',
].map(value => ({
    value,
    icon: socialNetworkIconMap[value],
}));

export function normalizeSocialNetwork(value) {
    const compact = String(value ?? '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '');

    return socialNetworkAliases[compact] ?? null;
}

export function socialNetworkIcon(value) {
    const normalized = normalizeSocialNetwork(value);
    return normalized ? socialNetworkIconMap[normalized] : null;
}
